export default "__VITE_ASSET__BbpMmBWB__"